module.exports = __webpack_public_path__ + "static/media/can.ca527a58.png";